var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07143 0.25L0.5 3.82143V16.6786H4.78571V20.25L8.35714 16.6786H11.2143L17.6429 10.25V0.25H4.07143ZM16.2143 9.53571L13.3571 12.3929H10.5L8 14.8929V12.3929H4.78571V1.67857H16.2143V9.53571Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0714 4.17857H12.6429V8.46429H14.0714V4.17857Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1429 4.17857H8.71429V8.46429H10.1429V4.17857Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.5e675d286a57e5889c9de85dd512d9c3.svg";
export { ForwardRef as ReactComponent };